import { Button } from '@zep-us/zus';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { ArrowRightIcon, LockFillIcon } from '@/icons';
import { cn } from '@/utils';
import { type QuizListItemThumbnailProps } from '../types/quiz-list-item.types';
export const QuizListItemThumbnail = ({
  thumbnailUrl,
  alt = 'Quiz thumbnail',
  onClick,
  className,
  isLocked,
  showHoverButton,
  quizCount
}: QuizListItemThumbnailProps) => {
  return <div className={cn('relative shrink-0 flex items-center justify-center overflow-hidden', className)} data-sentry-component="QuizListItemThumbnail" data-sentry-source-file="QuizListItemThumbnail.tsx">
      <img src={thumbnailUrl} alt={alt} className="h-full w-full object-cover" />
      {showHoverButton && onClick && !isLocked && <HoverEnterButton onClick={onClick} quizCount={quizCount} />}
      {isLocked && <LockBadge />}
    </div>;
};
const HoverEnterButton = ({
  onClick,
  quizCount
}: {
  onClick: () => void;
  quizCount?: number;
}) => {
  const {
    t
  } = useTranslation(['common']);
  return <Button rounded="full" size="sm" rightSlot={<ArrowRightIcon size="xs" />} variant="contained" onClick={e => {
    onClick();
    e.preventDefault();
  }} className={cn('invisible group-hover:visible group-hover:bg-[rgba(28,_27,_31,_0.54)] absolute left-1/2 top-1/2 size-[36px] -translate-x-1/2 -translate-y-1/2', 'w-auto z-10')} data-sentry-element="Button" data-sentry-component="HoverEnterButton" data-sentry-source-file="QuizListItemThumbnail.tsx">
      {quizCount ? `${quizCount} ${t('common.question')}` : t('global.enter.button')}
    </Button>;
};
const LockBadge = () => {
  return <div className={cn('absolute flex items-center justify-center', 'left-1/2 top-1/2 size-[36px] -translate-x-1/2 -translate-y-1/2')} data-sentry-component="LockBadge" data-sentry-source-file="QuizListItemThumbnail.tsx">
      <div className="absolute inset-0 rounded-full bg-opacity-white-8 backdrop-blur-[2px]" />
      <LockFillIcon size="md" fill={ICON_COLOR.default} className="z-10" data-sentry-element="LockFillIcon" data-sentry-source-file="QuizListItemThumbnail.tsx" />
    </div>;
};